import React from 'react';
import Common from './Component';
import Footer from './Footer';
const About=()=>{
    return (
        <div>
            <Common name="Welcome to New Digital Era " imgsrc={`https://images.unsplash.com/photo-1451187580459-43490279c0fa?ixlib=rb-1.2.1&auto=format&fit=crop&w=752&q=80`} visit="/contact" btnname="Contact Now"/>
            <Footer/>
        </div>
    )
}

export default About;